import Model from "./model";
import Question from "./question.model";

export default class Answer extends Model {
  public position: number = 1;
  public question_choice_id: number | null = null;
  public text: string | null = null;
  public question: Question | null = null;
}
